
export const alignPickerPopupBelow = (
  open,
  selector,
  { offsetUp = 0, padding = 12 } = {}
) => {
  if (!open) return;

  window.requestAnimationFrame(() => {
    const el =
      typeof selector === "string"
        ? document.querySelector(selector)
        : selector;

    if (!el) return;

    if (
      el.querySelector(
        ".ant-picker-month-panel, .ant-picker-year-panel, .ant-picker-decade-panel"
      )
    ) {
      return;
    }

    const rect = el.getBoundingClientRect();
    let top = rect.top - offsetUp;

    if (rect.bottom > window.innerHeight - padding) {
      top = Math.max(padding, window.innerHeight - rect.height - padding);
    }

    if (top < padding) top = padding;

    el.style.top = `${top}px`;
  });
};
